import { useTRPCAPI, useTRPCQuery } from '../../../trpc/trpc';
import { useShareTokenInput } from './useShareTokenInput';

interface UseArtistListeningScoreChartParams {
  artistId: string;
  date?: Date;
  rangeDays?: number;
  enabled?: boolean;
}

export const useArtistListeningScoreChart = ({
  artistId,
  date,
  rangeDays,
  enabled = true,
}: UseArtistListeningScoreChartParams) => {
  const trpcMusicAPI = useTRPCAPI();
  const shareTokenInput = useShareTokenInput();
  return useTRPCQuery(
    trpcMusicAPI.artists.listeningTrend.queryOptions(
      { artistId, date, rangeDays, ...shareTokenInput },
      { enabled: Boolean(artistId) && enabled }
    )
  );
};
